import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { SharedService } from '../../shared/shared.service';
import { BehaviorSubject, Subject } from 'rxjs';
import { MsPinService } from './ms-pin.service';

@Component({
  selector: 'app-ms-pin',
  templateUrl: './ms-pin.component.html',
  styleUrls: ['./ms-pin.component.scss']
})
export class MsPinComponent implements OnInit {

  displayedColumns: string[] = ['SNo', 'mspin', 'outlet', 'status', 'action'];
  public ELEMENT_DATA: any = [];
  dataSource = new MatTableDataSource(this.ELEMENT_DATA);
  isLoading: Subject<boolean> = new Subject<boolean>();
  @ViewChild(MatSort, { static: true })
  sort: MatSort = new MatSort;
  @ViewChild(MatPaginator, { static: true })
  paginator!: MatPaginator;
  msPinForm: FormGroup;
  public searchInput = new FormControl("");
  outletList: any;
  constructor(private toastr: ToastrService, private fb: FormBuilder, private sharedService: SharedService, private mspinService: MsPinService) {
    this.msPinForm = this.fb.group({
      mspin: ['', Validators.required],
      outlet_id: ['', Validators.required],
      status: ['', Validators.required]
    });
  }

  public isCreate: boolean = false;
  public isEdit: boolean = false;
  public submitted: boolean = false;

  ngOnInit() {
    this.getList();
    this.getAllRoles();
    this.getAllOutlet();
    this.searchInput.valueChanges.subscribe(() => {
      this.applyFilter();
    });
  }

  get f() { return this.msPinForm.controls; }

  add() {
    this.isCreate = true;
  }

  selectedObject: any = {}
  editData(object: any) {
    this.isEdit = true;
    this.selectedObject = object;
    this.msPinForm.patchValue({
      mspin: object.mspin,
      outlet_id: object.outlet_id,
      // flag: object.status ? 1 : 0
      status: object.status ? 1 : 0
    })
  }

  back() {
    this.clearForm();
    this.selectedObject = {};
    this.isCreate = false;
    this.isEdit = false;
    this.getList();
  }

  applyFilter() {
    const filterValue = this.searchInput.value ? this.searchInput.value.trim().toLowerCase() : '';
  
    this.dataSource.filterPredicate = (data: any, filter: string) => {
      const mspin = data.mspin.toLowerCase().includes(filter);
      const outlet = data?.outlet?.outlet_name.toLowerCase().includes(filter);
      return mspin || outlet;
    };
      this.dataSource.filter = filterValue;
  }

  clearSearch() {
    this.searchInput.setValue('');
    this.applyFilter();
  }

  create() {
    this.submitted = true
    if (this.msPinForm.valid) {
      const mspinData = this.msPinForm.value;
      let obj = {
        "mspin": mspinData.mspin,
        "outlet_id": mspinData.outlet_id,
        // "status": parseInt(mspinData.status),
        "flag": "create"
      }
      this.isLoading = new BehaviorSubject<boolean>(true);
      this.mspinService.mspinCrud(obj).subscribe((response: any) => {
        let responseData = response.body;
        if (responseData.responseCode == 200) {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.success("MSPIN created successfully!")
          this.back();
        } else {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.error(responseData.responseMessage)
        }
      }, (err) => {
        this.isLoading = new BehaviorSubject<boolean>(false);
        this.toastr.error(err)
      });
    }
  }

  update() {
    this.submitted = true
    if (this.msPinForm.valid) {
      const mspinData = this.msPinForm.value;
      let obj = {
        "mspin": mspinData.mspin,
        "outlet_id": mspinData.outlet_id,
        "status": parseInt(mspinData.status),
        "flag": "update",
        "id": this.selectedObject.id
      }
      this.isLoading = new BehaviorSubject<boolean>(true);
      this.mspinService.mspinCrud(obj).subscribe((response: any) => {
        let responseData = response.body;
        if (responseData.responseCode == 200) {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.success("MSPIN updated successfully!")
          this.back();
        } else {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.error(responseData.responseMessage)
        }
      }, (err) => {
        this.isLoading = new BehaviorSubject<boolean>(false);
        this.toastr.error(err)
      });
    }
  }

  clearForm() {
    this.submitted = false;
    this.msPinForm.patchValue({
      mspin: '',
      status: '',
      outlet_id: ''
    });
  }

  allowAplhabetsOnly(event: any) {
    this.sharedService.allowAlphabetsOnly(event);
  }

  getList() {
    let reqObject = {
      flag: 'list'
    }
    this.isLoading = new BehaviorSubject<boolean>(true);
    this.mspinService.mspinCrud(reqObject).subscribe((response: any) => {
      let responseData = response.body
      if (responseData.responseCode == 200) {
        this.isLoading = new BehaviorSubject<boolean>(false);
        this.ELEMENT_DATA = responseData.data        
        this.dataSource = new MatTableDataSource(this.ELEMENT_DATA);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
      } else {
        this.isLoading = new BehaviorSubject<boolean>(false);
      }
    }, (err) => {
      this.isLoading = new BehaviorSubject<boolean>(false);
    });
  }

  public roleList: any = [];
  getAllRoles() {
    let reqObject = {
      flag: 'list'
    }
    this.mspinService.roleCrud(reqObject).subscribe((response: any) => {
      let responseData = response.body
      if (responseData.responseCode == 200) {
        this.roleList = responseData.data
      }
    });
  }
  public outletlists: any = [];
  getAllOutlet() {
    this.mspinService.getAllOutlet().subscribe((response: any) => {
        let responseData = response.body;
        if (responseData.responseCode === 200) {
          this.outletlists = responseData.data.sort((a:any, b:any) => {
            return a.outlet_name.localeCompare(b.outlet_name);
          });
            console.log(this.outletlists, 'this.outletlists');
        this.roleList = responseData.data
      }
    });
  }
}
